import { ROLES, ROLE_PERMISSIONS } from "../constants";
export { ROLES, ROLE_PERMISSIONS };

// Resolves role from Cognito groups; priority: Admin > User > Disabled
export function resolveRoleFromGroups(cognitoGroups) {
  const groups = Array.isArray(cognitoGroups)
    ? cognitoGroups
    : typeof cognitoGroups === "string"
      ? [cognitoGroups]
      : [];

  if (groups.length === 0) return ROLES.DISABLED;

  if (groups.includes(ROLES.ADMIN)) return ROLES.ADMIN;
  if (groups.includes(ROLES.USER)) return ROLES.USER;
  if (groups.includes(ROLES.DISABLED)) return ROLES.DISABLED;

  return ROLES.DISABLED;
}

export function getPermissionsForRole(role) {
  return ROLE_PERMISSIONS[role] ?? new Set();
}
